<template>
  <div class="smt-accordion-container">

    <!-- Affichage du carret -->
    <div v-if="accordion" :class="[{ 'accordion': accordion }, 'smt-accordion-carret-container']" :id="accordionId">
      <span v-if="inAnnotationAxiom == false">&nbsp;&nbsp;&nbsp;</span>
      <button v-if="accordion" type="button"
        :class="['blanknode-accordion-button', { 'collapsed': !accordiontDisplayOpen }]" data-toggle="collapse"
        :data-target="'#' + accordionContentId" :aria-expanded="accordiontDisplayOpen"
        :aria-controls="accordionContentId" @click="toggleAccordion" />

      <!-- affichage du prédicat -->
      <TooltipLabel :title="predicatTitle" :label="predicatToShow" :inAnnotationAxiom="inAnnotationAxiom"
        :languages="languages" :negative="negative" />
      <div class="item" v-if="isOnlyNotLocalizedLang && inAnnotationAxiom && !accordiontDisplayOpen"
        style="display: flex;">
        <span>&nbsp;&nbsp;</span>
        <AttributeLanguageSelector :blankNodes="blankNodes" :simpleValues="simpleValues" />
      </div>

      <!-- affichage du nombre d'enfant -->
      <span v-if="accordion" :class="['blanknode-accordion-number', 'ml-1']">[
        {{ localNombre }} {{ localNombre > 1 ?
          'valeurs' : 'valeur' }} ]</span>
    </div>

    <div v-if="!accordion && predicat" style="display: flex;">
      <span v-if="!isAnnaonymous && !inAnnotationAxiom" class="property-value-prefix">&nbsp;&nbsp;&nbsp;</span>
      <TooltipLabel :title="predicatTitle" :label="predicatToShow" :inAnnotationAxiom="inAnnotationAxiom"
        :languages="languages" :negative="negative" />
      <div class="item" v-if="isOnlyNotLocalizedLang && inAnnotationAxiom" style="display: flex;">
        <span>&nbsp;&nbsp;</span>
        <AttributeLanguageSelector :blankNodes="blankNodes" :simpleValues="simpleValues" />
      </div>
    </div>


    <!-- Contenu -->
    <div :id="accordionContentId"
      :class="['blanknode-content-container', 'collapse', { 'show': accordiontDisplayOpen || !accordion }]"
      aria-labelledby="headingOne" :data-parent="'#' + accordionId">
      <slot></slot>
    </div>

  </div>
</template>

<script>
import StoreConfiguration from "../../store-configuration";
import BASIC_ATTRIBUTES from "../../enums/basic_attributes";

import ConceptsStore from "../../concepts-store";
export default {
  name: "SmtAccordion",
  props: {
    leftMargin: {
      type: Boolean,
      default: true
    },
    negative: {
      type: Boolean,
      default: false,
    },
    accordion: {
      type: Boolean,
      default: false
    },
    accordiontDisplayOpen: {
      type: Boolean,
      default: true
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
    showTree: {
      type: Boolean,
      default: false
    },
    parentKey: {
      type: String,
      default: ''
    },
    predicat: {
      type: String,
      default: ''
    },
    predicatTitle: {
      type: String,
      default: ''
    },
    property: {
      type: String,
      default: ''
    },
    values: {
      type: Array,
      default: () => []
    },
    blankNodes: {
      type: Array,
      default: () => []
    },
    multilingual: {
      type: Boolean,
      default: false,
    },
    isOnlyNotLocalizedLang: {
      type: Boolean,
      default: true,
    },
    isAnnaonymous: {
      type: Boolean,
      default: false,
    },
    inAnnotationAxiom: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
    simpleValues: {
      type: Array,
      default: () => [],
    },
  },


  /**
   * Surveille les changements de la route pour rafraîchir le composant
   * et pour sélectionner la langue si elle est définie dans les paramètres de la route.
   */
  watch: {
    'store.configurationsFiltresAxiomesChange'() {
      this.calculDucompteur();
    }

  },

  created() {
    this.calculDucompteur();
  },

  computed: {
    /**
     * Return un id unique pour l'accordeon en évitant les espaces et les majuscules
     */
    accordionId() {
      let key = StoreConfiguration.extractUriLastPart(this.parentKey);
      return `accordion-${key}`.toLowerCase().replace(/\s+/g, '');
    },
    /**
      * Return un id unique pour le contenu de accordeon en évitant les espaces et les majuscules
      */
    accordionContentId() {
      let key = StoreConfiguration.extractUriLastPart(this.parentKey);
      return `accordion-${key}-content`.toLowerCase().replace(/\s+/g, '');
    },
    predicatToShow() {
      return this.getPredicatTranslation(this.predicat);
    }
  },

  data() {
    return {
      storeConfiguration: StoreConfiguration.state,
      store: ConceptsStore.state,
      basicAttributes: {
        "array": Object.values(BASIC_ATTRIBUTES),
        "object": BASIC_ATTRIBUTES,
      },

      valeurText: undefined,
    }
  },
  methods: {
    /**
     * Recalcul du compteur d'éléments dans l'accordéon
     * Utilisé pour mettre à jour le nombre d'éléments après une modification des filtres sur les axiomes
     * @returns {void}
     */
    calculDucompteur() {
      const configurationsFiltresAxiomes = JSON.parse(localStorage.getItem('configurationsFiltresAxiomes'));
      let blankNodesToShow = JSON.parse(JSON.stringify(this.blankNodes));
      let logicalAxiomesChecked = false;
      let anonymousAxiomesChecked = false;
      configurationsFiltresAxiomes.forEach(config => {
        if (config.terminologyId === this.store.terminologyId) {
          logicalAxiomesChecked = config.configuration.logicalAxiomesChecked;
          anonymousAxiomesChecked = config.configuration.anonymousAxiomesChecked;
        }
      });

      //filtrer les axiomes logiques niveau 0
      if (!logicalAxiomesChecked) {
        blankNodesToShow = blankNodesToShow.filter(blankNode => {
          return blankNode.blankNodeType !== 'LOGICAL_AXIOM';
        });
      }
      //filtrer les axiomes anonymes niveau 0
      if (!anonymousAxiomesChecked) {
        // filter 
        blankNodesToShow = blankNodesToShow.filter(blankNode => {
          return blankNode.blankNodeType !== 'ANONYMOUS_ANNOTATION';
        });
      }
      this.localNombre = blankNodesToShow.length + this.simpleValues.length;
    },

    /**
     * Gère l'affichage de l'accordéon en mode fermé/ouvert
     * Si l'accordéon est ouvert, il le ferme et vice versa.
     * @returns {void}
     */
    toggleAccordion() {
      this.accordiontDisplayOpen = !this.accordiontDisplayOpen;
    },

    /**
     * Gestion de l'affichage des prédicats dans les noeuds blancs
     * @param predicat prédicat du noeud blanc
     */
    getPredicatTranslation(predicat) {
      if (this.storeConfiguration.current?.concepts_details?.attributs?.label_affichage) {
        let basicUri = BASIC_ATTRIBUTES[predicat] ? BASIC_ATTRIBUTES[predicat] : ' ';

        let translations;
        if (this.storeConfiguration.current?.concepts_details?.attributs?.label_affichage[predicat]) {
          translations = this.storeConfiguration.current.concepts_details.attributs.label_affichage[predicat];
        } else if (this.storeConfiguration.current?.concepts_details?.attributs?.label_affichage[basicUri]) {
          translations = this.storeConfiguration.current.concepts_details.attributs.label_affichage[basicUri];
        } else {
          translations = [];
        }

        if (translations.length && translations.find(x => x.lang === this.$route.query.lang)) {
          return translations.filter(x => x.lang === this.$route.query.lang)[0].name;
        }
      }

      // No label of the predicat is available so take the last part of the URI of the predicat.
      const regexMatch = predicat.match('([^\\/|#|:]+$)');
      return regexMatch === null ? predicat : regexMatch[1];
    },

    /**
     * 
     * @param property Retourne si l'attribut doit être affiché dans un accordeon ouvert ou fermé par défaut
     */
    isAccordionOpen(property) {
      let basicUri = BASIC_ATTRIBUTES[property] ? BASIC_ATTRIBUTES[property] : ' ';
      const status = this.storeConfiguration.current.concepts_details.affichage.avec_accordeon[property]?.etat || this.storeConfiguration.current.concepts_details.affichage.avec_accordeon[basicUri]?.etat;
      if (status === 'open') return 0;
      return undefined;
    },
  }

}

</script>

<style lang="scss" scoped>
.smt-accordion-container {
  display: flex;
  flex-direction: column;
}

.accordion-property-container {
  padding-bottom: 15px;
}

.blanknode-accordion-button:not(.collapsed)~.blanknode-accordion-number {
  display: none;
}

.blanknode-accordion-button::before {
  content: ">";
  color: var(--v-primary-base);
  font-weight: bold;
  display: inline-block;
  margin-right: 5px;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.blanknode-accordion-button.collapsed {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
}
</style>